import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  IconButton,
  Button,
  Chip,
  Popover,
  List,
  ListItem,
  ListItemButton,
  Tooltip,
} from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { editInteraction, createInteraction, getInteraction } from "../../Services/ExperienceApi";

const availableEvents = [
  { label: 'On click', value: 'click' },
  { label: 'On double click', value: 'dblclick' },
  { label: 'On right click', value: 'rightclick' },
  { label: 'On mouse out', value: 'mouseout' },
  { label: 'On mouse in', value: 'mouseover' },
];
type Interaction = {
  selector: string;
  events: string[]; // Clearly tell TS this is a string array
  listenOnce: boolean;
};
const Interaction = () => {
  const [interactions, setInteractions] = useState<Interaction[]>([
    { selector: "", events: [], listenOnce: true },
  ]);

  const [anchorEls, setAnchorEls] = useState<any>({});
  const [title, setTitle] = useState("Interaction");
  const [titleError, setTitleError] = useState(false);

  const location = useLocation();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const fullInteractionId = location.state?.data.id;
    const interactionId = fullInteractionId?.split("_")[1];
    const sessionData = sessionStorage.getItem("pendingNodeAddition");
    const sessionObj = sessionData ? JSON.parse(sessionData) : {};
    const experienceId =
      location.state?.data.experinceId || sessionObj.experinceId;
    const fullSegmentId = location.state?.data.segmentId || sessionObj.segmentId;
    const segmentId = location.state?.data.segmentId
      ? fullSegmentId.split("_")[1]
      : fullSegmentId;
   useEffect(() => {
      const fetchExperience = async () => {
        if (segmentId && experienceId && interactionId) {
          const response = await getInteraction(experienceId, segmentId, interactionId);
          if (response.success === true && response) {
            const intData = response.data;
            setTitle(intData.title)
            const formattedInteractions = intData.interactions?.map((item: any) => ({
              selector: item.element || "",
              events: item.event_listeners || [],
              listenOnce: item.listen_once ?? true,
            })) || [];
    
            setInteractions(formattedInteractions.length > 0 ? formattedInteractions : [
              { selector: "", events: [], listenOnce: true }
            ]);
          }
        }
      };
      fetchExperience();
    }, [segmentId, experienceId, interactionId]);
  const handleAddInteraction = () => {
    setInteractions([
      ...interactions,
      { selector: "", events: [], listenOnce: true },
    ]);
  };

  const handleRemoveInteraction = (indexToRemove: any) => {
    setInteractions((prevInteractions) =>
      prevInteractions.filter((_, index) => index !== indexToRemove)
    );
  };
  

  const handleSelectorChange = (index: any, value: any) => {
    const updated = [...interactions];
    updated[index].selector = value;
    setInteractions(updated);
  };

  const handleToggleListenOnce = (index: any, checked: any) => {
    const updated = [...interactions];
    updated[index].listenOnce = checked;
    setInteractions(updated);
  };

  const handleOpenPopover = (index: any, event: any) => {
    setAnchorEls({ ...anchorEls, [index]: event.currentTarget });
  };

  const handleClosePopover = (index: any) => {
    setAnchorEls({ ...anchorEls, [index]: null });
  };

  const handleAddEvent = (index: number, eventName: string) => {
    const updated = [...interactions];
    if (!updated[index].events.includes(eventName)) {
      updated[index].events.push(eventName);
      setInteractions(updated);
    }
    handleClosePopover(index);
  };

  const handleRemoveEvent = (index: any, eventName: any) => {
    const updated = [...interactions];
    updated[index].events = updated[index].events.filter(
      (e) => e !== eventName
    );
    setInteractions(updated);
  };

  const handleSave = async () => {
    if (!title.trim()) {
      setTitleError(true);
      return;
    }
    const payload = {
       title: title,
      interactions: interactions.map((i) => ({
        element: i.selector,
        event_listeners: i.events,
        listen_once: i.listenOnce,
      })),
    };
    let response;
    try {
         setLoading(true);
         if (interactionId) {
           response = await editInteraction(
             experienceId,
             segmentId,
             interactionId,
             payload
           );
         } else {
           response = await createInteraction(experienceId, segmentId, payload);
         }
         if (response.success === true) {
           toast.success(response.message);
           navigate(-1);
         } else {
           toast.error(response.error);
         }
       } catch (err) {
         console.error(err);
         toast.error("Something went wrong!");
       } finally {
         setLoading(false);
       }
  };
  const onback = () => {
    navigate(`/edit-experience/${experienceId}`);
  };

  return (
    <div className="templates">
      {/* Header Section */}
      <Grid container className="templates__header">
        <Grid
          size={{ xs: 12, md: 3, sm: 6 }}
          className="templates__header--search"
        >
          <div className="d-center">
            <span className="Icon">
              <IconButton aria-label="close">
              
              <ArrowbackIcon onClick={onback}  />
              </IconButton>{" "}
            </span>{" "}
            <h2> Interaction</h2> 
          </div>
        </Grid>
        <Grid
          size={{ xs: 12, md: 9, sm: 6 }}
          className="templates__header--button "
        >
          <Box className="button-heading">
            <Button
              className="button"
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
                "&:hover": {
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="contained"
              color="error"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? <span className="loader" /> : "Save"}
            </Button>
            <Button
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="outlined"
              onClick={onback}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box className="editSegment__container" mt={2}>
        <Grid container alignItems={"center"}>
          <Grid size={{ xs: 12, md: 12, sm: 12 }}>
            <div className="editSegment__container--heading">
              <p>Add an event to the element on the page</p>
            </div>
          </Grid>
        </Grid>
        <Grid container alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 3 }}>
            <div className="editSegment__container--heading">
              <h2>TITLE OF CARD :</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 10, sm: 9 }}
            className="editSegment__container--heading"
          >
            <TextField
              fullWidth
              required
                value={title}
                error={titleError}
              helperText={titleError ? "Title is required" : ""}
              onChange={(e) => {
                const value = e.target.value;
                setTitle(value);
                if (value.trim()) {
                  setTitleError(false);
                }
              }}
              variant="standard"
            />
          </Grid>
        </Grid>

        <div className="editSegment__container--heading">
          <h3>Properties</h3>
        </div>
        <div className="editSegment__container">
          <div className="editSegment__container--innerheading bb-1 ">
            {interactions.map((item, index) => (
              <Grid
                container
                spacing={2}
                alignItems="center"
                key={index}
                sx={{ mb: 1 }}
              >
                <Grid size={{ xs: 12, md: 6, sm: 5 }}>
                  <label> ELEMENTS</label>
                  <TextField
                    sx={{ marginTop: "5px" }}
                    fullWidth
                    placeholder="Insert the .classes and #IDs of any elements on the page"
                    value={item.selector}
                    onChange={(e) =>
                      handleSelectorChange(index, e.target.value)
                    }
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, sm: 4 }}>
                  <label> EVENTS LISTNERS</label>
                  <Box
                    sx={{
                      marginTop: "5px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      border: "1px solid #ccc",
                      borderRadius: 1,
                      px: 1,
                      py: 1,
                      minHeight: "56px",
                      alignItems: "center",
                    }}
                  >
                    {item.events.map((evt, i) => (
                      <Chip
                        key={i}
                        label={evt}
                        onDelete={() => handleRemoveEvent(index, evt)}
                      />
                    ))}
                    <Button
                      size="small"
                      onClick={(e) => handleOpenPopover(index, e)}
                    >
                      Add...
                    </Button>

                    <Popover
                      open={Boolean(anchorEls[index])}
                      anchorEl={anchorEls[index]}
                      onClose={() => handleClosePopover(index)}
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    >
                      <List dense>
                        {availableEvents.map((evt, idx) => (
                          <ListItem disablePadding key={idx}>
                            <ListItemButton
                              onClick={() => handleAddEvent(index, evt.value)}
                            >
                              {evt.label}
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Popover>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 2, sm: 3 }}>
                  <label> LISTEN ONCE</label>
                  <Box marginTop={'15px'} display={'flex'} gap={'20px'} justifyContent={'space-between'} alignContent={'center'}>
                    <Tooltip
                      title="Turning this switch on will remove the event listener after the first time it is triggered."
                      arrow
                      placement="bottom"
                    >
                      <div className="switch-wrapper user-segment-toggle">
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={item.listenOnce}
                            onChange={(e) =>
                              handleToggleListenOnce(index, e.target.checked)
                            }
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    </Tooltip>

                    <div>
                    <IconButton
                    className="Icon"
                    color="error"
                    onClick={() => handleRemoveInteraction(index)}
                    disabled={interactions.length === 1}
                  >
                    <DeleteOutline fontSize="medium" />
              </IconButton>
                    </div>
                  </Box>
                </Grid>
              </Grid>
            ))}
            <button className="button-submit" onClick={handleAddInteraction}>
              <span className="Icon">
                <AddIcon />
              </span>
              ADD A NEW INTERACTION
            </button>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default Interaction;
